var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinglepersonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5C5.09674 0.5 5.66903 0.737053 6.09099 1.15901C6.51295 1.58097 6.75 2.15326 6.75 2.75C6.75 3.34674 6.51295 3.91903 6.09099 4.34099C5.66903 4.76295 5.09674 5 4.5 5C3.90326 5 3.33097 4.76295 2.90901 4.34099C2.48705 3.91903 2.25 3.34674 2.25 2.75C2.25 2.15326 2.48705 1.58097 2.90901 1.15901C3.33097 0.737053 3.90326 0.5 4.5 0.5ZM4.5 6.125C6.98625 6.125 9 7.13188 9 8.375V9.5H0V8.375C0 7.13188 2.01375 6.125 4.5 6.125Z",
    fill: "#5B6100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglepersonIcon);
export default __webpack_public_path__ + "static/media/singleperson_icon.318dba4e205d5de652494fd0eafd5f69.svg";
export { ForwardRef as ReactComponent };